<template>
  <div>
    <!-- 查看详情弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="订单信息"
      :visible.sync="infoDialogVisible"
      :before-close="infoHandleClose"
      width="1600px"
      center
      top="5vh"
    >
      <el-divider></el-divider>
      <div class="infoForm">
          <div class="form_input">
              <div class="input_box">
                 <span>用户姓名：</span>
                 <el-input v-model="form.name" disabled></el-input>
              </div>
              <div  class="input_box">
                 <span>联系电话：</span>
                 <el-input v-model="form.phone" disabled></el-input>
              </div>
              <div  class="input_box">
                 <span>第三方编号：</span>
                 <el-input v-model="form.id" disabled></el-input>
              </div>
              <div class="notes">
                 <span>备注：</span>
                 <el-input placeholder="-" disabled></el-input>
              </div>
          </div>
          <div class="orderNumbers">
            <div>
              订单编号：{{form.OrderNumber}}
            </div>
            <div>
              下单时间：{{form.CreateTime}}
            </div>
          </div>
          <div style="margin-top:1.8rem;">
            <el-table
              :data="form.product"
              :header-cell-style="tableHeaderColor"
              :cell-style="cellStyle"
              style="width: 100%"
            >
              <el-table-column prop="CreateTime" label="产品名称" width="200" >
                <template slot-scope="scope">
                    {{ scope.row.OrderAll.productname }}
                </template>
              </el-table-column>
              <el-table-column prop="Count" label="数量"></el-table-column>
              <el-table-column prop="OrderNumber" label="代理价">
                <template slot-scope="scope">
                    {{ scope.row.OrderAll.agentprice }}
                </template>
              </el-table-column>
              <el-table-column  label="合计">
                <template slot-scope="scope">
                    {{ scope.row.OrderAll.agentprice * scope.row.Count }}
                </template>
              </el-table-column>
              <el-table-column label="消费日期" width="260">
                <template slot-scope="scope">
                  <div v-if="scope.row.playdate=='-1'||scope.row.playdate==''">
                    {{ scope.row.OrderAll.consumebegindate}}-{{ scope.row.OrderAll.consumeenddate }}
                  </div>
                  <div v-else>
                    {{scope.row.playdate}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column  label="可用星期" width="200" >
                <template slot-scope="scope" >
                    <div v-if="scope.row.playdate=='-1'">
                      {{ scope.row.OrderAll.arr}}
                    </div>
                </template>
              </el-table-column>
              <el-table-column  label="可用时间">
                
                <template slot-scope="scope">
                    {{ scope.row.OrderAll.usebegintime}}-{{ scope.row.OrderAll.useendtime }}
                </template>
              </el-table-column>
              <el-table-column  prop="CountUse"   label="已使用"></el-table-column>
              <el-table-column label="未使用">
                <template slot-scope="scope">
                    {{ scope.row.Count-scope.row.CountUse - scope.row.CancleCount }}
                </template>
              </el-table-column>
              <el-table-column prop="CancleCount" label="退单">
              </el-table-column>
              <el-table-column  label="可退数量">
                <template slot-scope="scope">
                    {{ scope.row.Count-scope.row.CountUse - scope.row.CancleCount }}
                </template>
              </el-table-column>
              <el-table-column  label="是否可退">
                <template slot-scope="scope">
                    {{ scope.row.OrderAll.returnflag=='0'?'可退':'不可退' }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="bottom_button">
            <!-- <div @click="SmaCf">重发短信</div> -->
          </div>
      </div>
    </el-dialog>
    <!-- 查看详情弹框结束 -->
  </div>
</template>

<script>
import {getDistributorTwoOrderInfo} from '@/request/index.js'
export default {
  props:['order_id'],
  data() {
    return {
      infoDialogVisible: false, // 产品详情
      form: {
      }
    };
  },
  created(){
    this.detail()
  },
  methods: {
    // 订单详情
    detail(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        order_id:this.order_id
      }
      getDistributorTwoOrderInfo(data).then(res=>{
        if(res.data.status=='ok'){
          this.form = {
            name:res.data.result.consumer,
            phone:res.data.result.Mobile,
            id:res.data.result.OnlyCode,
            msk:'',
            OrderNumber:res.data.result.OrderNumber,
            CreateTime:res.data.result.order_detail[0].CreateTime,
            product:res.data.result.order_detail,
            Mobile:res.data.result.Mobile
          }
          this.form.product.map(item=>{
            item.Ktnum =  item.Count-item.CountUse-item.CancleCount
            item.flags = item.OrderAll.numberflag=='1'?'是':'否'
            let arr = ''
            console.log(item.OrderAll.weeks)
            if(item.OrderAll.weeks){
              JSON.parse(item.OrderAll.weeks).map(itm=>{
                switch(itm){
                  case '1':
                  arr+='一'+'、'
                    break;
                case '2':
                  arr+='二'+'、'
                    break;
                case '3':
                  arr+='三'+'、'
                    break;
                case '4':
                  arr+='四'+'、'
                    break;
                case '5':
                  arr+='五'+'、'
                    break;
                case '6':
                  arr+='六'+'、'
                    break;
                case '7':
                  arr+='日'
                    break;
                default:
                    break;  
                }
              })
              item.OrderAll.arr = arr
            }
          })
        }
      })
    },
    // 产品详情
    Info() {
      this.infoDialogVisible = true;
    },
    // 产品详情
    infoHandleClose() {
      this.infoDialogVisible = false;
      this.$emit('CloseGb')
    },
     // 表头设置
     tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.infoForm{
  box-sizing: border-box;
  .form_input{
    width: 100%;
    display: flex;
    align-items: center;
    .input_box{
      display: flex;
      align-items: center;
      margin-right: 1.9rem;
      /deep/.el-input{
        width: 22.2rem;
      }
      span{
        color: #666;
        text-align: right;
        font-family: OPPOSans;
        font-size: 1.4rem;
        display: block;
        width: 8.4rem;
      }
    }
    .notes{
      flex: 1;
      display: flex;
      align-items: center;
      /deep/.el-input{
        width: 90%;
      }
      span{
        color: #666;
        text-align: right;
        font-family: OPPOSans;
        font-size: 1.4rem;
        display: block;
        width: 5rem;
      }
    }
  }
  .orderNumbers{
    display: flex;
    align-items: center;
    margin-top: 3rem;
    div{
      color: #666;
      font-family: OPPOSans;
      font-size: 1.4rem;
      font-style: normal;
      font-weight: 400;
      margin-right: 2rem;
    }
  }
}
.bottom_button{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
  div{
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #246DEB;
    color: #fff;
    color: #FFF;
    text-align: center;
    font-size: 1.4rem;
    margin-right: 2rem;
    
  }
}
/deep/.el-input__inner{
  background: #fff !important;
  color: #666 !important;
}
</style>